import deskGroupsService from '@/api/deskgroups'
import {DESK_GROUPS} from '../types'
import utils from '@/utils/utils.js'
import strings from '@/strings'

export default {
  namespaced: true,
  state: {
    deskGroups: [],
    groupId: null,
    groupName: '',
    groupDesks: [],
    availableDesks: [],
    deskAttributes: [],
    isDownloadingFile: false
  },
  getters: {
    groupName(state) {
      return state.groupName
    },
    groupDesk(state) {
      return state.groupDesks
    },
    deskAttributes(state) {
      return state.deskAttributes
    },
    isDownloadingFile: (state) => {
      return state.isDownloadingFile
    },
  },
  mutations: {
    [DESK_GROUPS.SET_GROUPS](state, deskGroups) {
      state.deskGroups = deskGroups
    },
    [DESK_GROUPS.SET_ID] (state, id) {
      state.groupId = id
    },
    [DESK_GROUPS.SET_GROUP_NAME] (state, groupName) {
      state.groupName = groupName
    },
    [DESK_GROUPS.SET_GROUP_DESKS] (state, desks) {
      state.groupDesks = desks
    },
    [DESK_GROUPS.SET_AVAILABLE_DESKS] (state, availableDesks) {
      state.availableDesks = availableDesks
    },
    [DESK_GROUPS.SET_DESK_ATTRIBUTES] (state, deskAttributes) {
      state.deskAttributes = deskAttributes
    },
    [DESK_GROUPS.SET_IS_DOWNLOADING_FILE] (state, value) {
      state.isDownloadingFile = value
    }
  },
  actions: {
    async getDeskGroups ({dispatch, commit}) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        let response = await deskGroupsService.getDeskGroups()
        commit(DESK_GROUPS.SET_GROUPS, response.data)
        dispatch('resetGroup')
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async getDeskGroupsBySite ({dispatch, commit}, siteId) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        let response = await deskGroupsService.getDeskGroupsBySite(siteId)
        commit(DESK_GROUPS.SET_GROUPS_BY_SITE, response.data)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async getDeskGroup ({dispatch}, id) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        let response = await deskGroupsService.getDeskGroup(id)
        let desks = response.data.desks.map( resp => {
          return {
            name:`${resp.name} (${resp.locationName})`,
            locationId: resp.locationId,
            id: resp.id
          }
        })
        dispatch('setId', response.data.id)
        dispatch('setGroupName', response.data.name)
        dispatch('setDeskAttributes', response.data.deskAttributes.map( item => item.id))
        dispatch('setDesk', desks)
      } finally {
          dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveGroupStore ({dispatch, state}, cancelFutureBookings) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        let group = {
          id: state.groupId,
          name: state.groupName,
          desks: state.groupDesks.map( item => item.id),
          deskAttributes: state.deskAttributes,
          cancelFutureBookings
        }
        await deskGroupsService.saveGroup(group)
        dispatch('Global/showMessage', state.groupId ? 'editGroupSuccessfully' : 'addGroupSuccessfully', {root: true})
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async deleteGroup ({dispatch}, params) {
      dispatch('Global/showLoading', null, {root: true})
      try{
        await deskGroupsService.deleteGroup(params.groupId, params.cancelFutureBookings)
        await dispatch('getDeskGroups')
        dispatch('Global/showMessage', 'removeGroupSuccessfully', {root: true})

      } catch(error) {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async downloadFile ({dispatch}) {
      try {
        const { maxTimeToWait, statusProcessed, initialRetry, initialSumTimeToWait } = strings.downloadFile

        const initDownload = async (retries = initialRetry, sumTimeToWait = initialSumTimeToWait) => {
          const response = await deskGroupsService.getFile()
          if (response.status === statusProcessed) {
            dispatch('setIsDownloadingFile', false)
            let contentType = response.headers['content-type']
            let blob = new Blob([response.data], { type: contentType })
            utils.handleDownload(blob , 'desk_groups.xlsx')
          } else {
            dispatch('setIsDownloadingFile', true)
            const result = await utils.exponentialBackoffProgress(retries, sumTimeToWait, maxTimeToWait)
            await utils.waitFor(result.timeToWait);
            return initDownload(retries + 1, result.newSumTimeToWait, result.progress);
          }
        }
        await initDownload();

      } catch (e) {
        dispatch('setIsDownloadingFile', false)
        dispatch('Global/showMessage', 'errorDefault', {root: true})
      }
    },
    setId({commit}, id){
      commit(DESK_GROUPS.SET_ID, id)
    },
    setGroupName({commit}, groupName){
      commit(DESK_GROUPS.SET_GROUP_NAME, groupName)
    },
    setDesk({commit}, desk){
      commit(DESK_GROUPS.SET_GROUP_DESKS, desk)
    },
    setDeskAttributes({commit}, deskAttributes){
      commit(DESK_GROUPS.SET_DESK_ATTRIBUTES, deskAttributes)
    },
    setAvailableDesks({commit}, availableDesks){
      let listDesk = []
      availableDesks.forEach(local => {
        let objDesk = undefined
        local.desks.forEach(desk => {
          objDesk = {
            name:`${desk.name} (${local.locationName})`,
            locationId: local.locationId,
            id: desk.id
          }
          listDesk.push(objDesk)
        })
      })
      commit(DESK_GROUPS.SET_AVAILABLE_DESKS, listDesk)
    },
    setIsDownloadingFile ({commit}, value) {
      commit(DESK_GROUPS.SET_IS_DOWNLOADING_FILE, value)
    },
    resetGroup({dispatch}){
      dispatch('setId', null)
      dispatch('setGroupName', '')
      dispatch('setDesk', [])
    }
  }
}
